import './page/llm-assignment-list';
import './component/llm-assignment-form';

Shopware.Module.register('topdata-llm-connect-llm-assignment', {
    type: 'plugin',
    name: 'LLM Assignments',
    title: 'TopdataLlmConnectSW6.assignment.mainMenuItemGeneral',
    description: 'TopdataLlmConnectSW6.assignment.descriptionTextModule',
    color: '#009688',
    icon: 'regular-shuffle',

    routes: {
        list: {
            component: 'topdata-llm-connect-llm-assignment-list',
            path: 'list',
            meta: {
                privilege: 'system.plugin_maintenance',
            },
        },
    },

    navigation: [{
        id: 'topdata-llm-connect-llm-assignment',
        label: 'TopdataLlmConnectSW6.assignment.mainMenuItemGeneral',
        color: '#009688',
        path: 'topdata.llm.connect.llm.assignment.list',
        icon: 'regular-shuffle',
        position: 30,
        parent: 'topdata-llm-connect',
    }],
});